module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-layer"
  }, [_c('div', {
    staticClass: "hero is-fullheight"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container has-text-centered"
  }, [_c('span', {
    staticClass: "icon is-large has-text-white-ter"
  }, [_c('i', {
    staticClass: "fa fa-3x fa-question-circle-o"
  })]), _vm._v(" "), _c('h1', {
    staticClass: "title has-text-white-ter"
  }, [_vm._v("Error 404")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle has-text-white-ter"
  }, [_vm._v("Resource not found!")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a43bb0e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ErrorPage.vue
// module id = 337
// module chunks = 1